import React from 'react'
import {Icon} from '@chakra-ui/react'

const TimeIcon = (props) => {
    return (
        <Icon viewBox="0 0 40 40" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.49305 7.49329C10.8101 4.17624 15.309 2.31274 20 2.31274C24.691 2.31274 29.1899 4.17624 32.507 7.49329C35.824 10.8103 37.6875 15.3092 37.6875 20.0002C37.6875 24.6913 35.824 29.1901 32.507 32.5072C29.1899 35.8242 24.691 37.6877 20 37.6877C15.309 37.6877 10.8101 35.8242 7.49305 32.5072C4.176 29.1901 2.3125 24.6913 2.3125 20.0002C2.3125 15.3092 4.176 10.8103 7.49305 7.49329ZM20 5.31274C16.1046 5.31274 12.3688 6.86017 9.61437 9.61461C6.85993 12.3691 5.3125 16.1049 5.3125 20.0002C5.3125 23.8956 6.85993 27.6314 9.61437 30.3859C12.3688 33.1403 16.1046 34.6877 20 34.6877C23.8954 34.6877 27.6312 33.1403 30.3856 30.3859C33.1401 27.6314 34.6875 23.8956 34.6875 20.0002C34.6875 16.1049 33.1401 12.3691 30.3856 9.61461C27.6312 6.86017 23.8954 5.31274 20 5.31274Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.5 12.719V20.0002C21.5 20.8287 20.8284 21.5002 20 21.5002C19.1716 21.5002 18.5 20.8287 18.5 20.0002V12.719H21.5Z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.9393 18.9396C19.5251 18.3538 20.4749 18.3538 21.0607 18.9396L28.1213 26.0002L26 28.1216L18.9393 21.0609C18.3536 20.4751 18.3536 19.5254 18.9393 18.9396Z"
                fill="currentColor"
            />
        </Icon>
    )
}

export default TimeIcon
